module.exports = "https://cdn-skillquest.mathletics.com/app/184/assets/images/01888f59e4ca633e47a4b51ddae9ced7.svg";